export default function extractQueryTransformer(queries) {
  return queries.map(({ query }) => query);
}
